export let objMap = new Map();
let uniqueIdCounter = 0;

const font = "font-size: 1.2rem; color: rgba(0,0,0,0.7);";

function cardBrandBadge(brand) {
  if (!brand) return "";
  const b = String(brand).toLowerCase();
  const map = {
    visa: "💳 VISA",
    mastercard: "💳 MC",
    "american express": "💳 AMEX",
    amex: "💳 AMEX",
    discover: "💳 DISC",
    unionpay: "💳 UNIONPAY"
  };
  const label = map[b] || `💳 ${brand}`;
  return `<span style="margin-right:6px; font-size: 0.95rem; opacity: 0.9;">${label}</span>`;
}

function generateButton(action, type, s) {
  const uniqueId = `btn-${uniqueIdCounter++}`;
  let actionText = "";
  let isDisabled = true;
  const entity = s.asset;
  let className = "";

  switch (action) {
    case "subscription":
      className = "button-cancel";
      if (s.status === "canceled" || s.status === "cancelation_scheduled") {
        actionText = s.status === "cancelation_scheduled" ? "Cancel scheduled" : "Canceled";
        isDisabled = true;
      } else {
        actionText = "Cancel";
        isDisabled = !s.cancelable;
      }
      break;
    case "charge":
      className = "button-refund";
      if (s.status?.includes("refunded")) {
        actionText = "Refunded";
        isDisabled = true;
      } else {
        actionText = "Refund";
        isDisabled = !s.refundable;
      }
      break;
    default:
      actionText = "WTF?";
      break;
  }

  objMap.set(uniqueId, {
    object: s,
    action: actionText.toLowerCase(),
    platform: type,
    object_type: action,
    entity,
    isDisabled,
    className
  });

  // Avoid <br/> if this is a refund (not 50%) button
  const isRefundButton = action === "charge" && className === "button-refund";
  return (
    JSON.stringify({
      uniqueId,
      actionText,
      isDisabled,
      ...(className ? { className } : {}),
      entity
    }) + (isRefundButton ? "" : "<br/>")
  );
}

function generateRefund50Button(action, type, s) {
  if (action === "charge" && s.status?.includes("refunded")) return "<br/>";

  const uniqueId = `btn-${uniqueIdCounter++}`;
  let actionText = "Refund 50%";
  let isDisabled = true;
  const entity = s.asset;
  let className = "button-refund-50";

  if (action === "charge") {
    isDisabled = !s.refundable;
  }

  objMap.set(uniqueId, {
    object: s,
    action: "refund50",
    platform: type,
    object_type: action,
    entity,
    isDisabled,
    className
  });
  return (
    JSON.stringify({
      uniqueId,
      actionText,
      isDisabled,
      ...(className ? { className } : {}),
      entity
    }) + "<br/>"
  );
}

function formatDate(date) {
  const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric", year: "numeric" };
  const timeOptions: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "numeric", hour12: true };
  const formattedDate = new Date(date).toLocaleDateString("en-US", options);
  const formattedTime = new Date(date).toLocaleTimeString("en-US", timeOptions);
  return `${formattedDate} ${formattedTime}`;
}

function messageBuilderForPaymentSystem(type = "note", data, platform) {
  let noteRemark = "";
  for (const c of data.charges) {
    const chargeLabel = c.product_asset || c.asset;
    const asset =
      type === "html" ? `<span style="${font}">[${chargeLabel}]</span>` : `[${chargeLabel}]`;
    const brand = c.brand ? cardBrandBadge(c.brand) : "";
    const testBadge = c.is_test ? `<b>[TEST]</b> ` : "";
    const invoiceLink =
      type === "html" && c.invoice_url
        ? ` <a href="${c.invoice_url}" target="_blank" rel="noopener">🧾 invoice</a>`
        : "";
    noteRemark += `${asset} ${testBadge}${brand}<b>Upsell</b> ${c.amount} (${formatDate(c.created)}) is ${c.status}${invoiceLink}`;
    if (type === "html") {
      if (c.auth_code)
        noteRemark += ` <span style="color: darkred;">(auth: ${c.auth_code})</span> `;
      noteRemark += generateButton("charge", platform, c);
      noteRemark += generateRefund50Button("charge", platform, c);
    } else noteRemark += `<br>`;
  }
  for (const s of data.subscriptions) {
    const subLabel = s.product_asset || s.asset;
    const asset =
      type === "html" ? `<span style="${font}">[${subLabel}]</span>` : `[${subLabel}]`;
    const subTestBadge = s.is_test ? `<b>[TEST]</b> ` : "";
    noteRemark += `${asset} ${subTestBadge}<b>Subscription</b> created ${formatDate(s.created)} is ${s.status} ${
      s.canceled_at ? `at ${formatDate(s.canceled_at)}` : ""
    }`;
    if (type === "html") noteRemark += generateButton("subscription", platform, s);
    else noteRemark += `<br>`;
    s.charges.forEach((charge) => {
      const brand = charge.brand ? cardBrandBadge(charge.brand) : "";
      const reasonMap = {
        subscription_create: "sub create",
        subscription_cycle: "sub update",
        subscription_update: "sub update",
        subscription_threshold: "sub update"
      };
      const reason = reasonMap[charge.billing_reason] || "payment";
      const chargeTestBadge = charge.is_test ? `<b>[TEST]</b> ` : "";
      const chargeInvoiceLink =
        type === "html" && charge.invoice_url
          ? ` <a href="${charge.invoice_url}" target="_blank" rel="noopener">🧾 invoice</a>`
          : "";
      noteRemark += `${asset} ${chargeTestBadge}${brand}<b>Payment</b> (${reason}) ${charge.amount} (${formatDate(charge.created)}) is ${
        charge.status
      }${chargeInvoiceLink}`;
      if (type === "html") {
        if (charge.auth_code) {
          noteRemark += ` <span style="color: darkred;">(auth: ${charge.auth_code})</span> `;
        }
        noteRemark += generateButton("charge", platform, charge);
        noteRemark += generateRefund50Button("charge", platform, charge);
      } else noteRemark += `<br>`;
    });
  }
  return noteRemark;
}

export function messageBuilderForStripe(type = "note", data) {
  if (!data) return "";
  let message = "";
  const platform = "<br/><u><b>Stripe</b></u><br/>";
  console.log("data", data, typeof data);
  if (!Array.isArray(data)) {
    console.error("Data is not an array");
    return;
  }
  for (const d of data) {
    if (d.subscriptions?.length || d.charges?.length) {
      message += messageBuilderForPaymentSystem(type, d, "stripe");
    } else if (d.success === false && d.user) {
      message += `<b>${d.name}</b> ${d.noteRemark}</br>`;
    }
  }
  if (message === "") message = "no subscriptions & charges found<br/>";
  return platform + message;
}

export function messageBuilderForPaypro(type = "note", data) {
  if (!data) return "";
  let message = "";
  const platform = "<br/><u><b>Paypro</b></u><br/>";

  for (const d of data) {
    if (d.success && (d.subscriptions?.length || d.charges?.length)) {
      message += messageBuilderForPaymentSystem(type, d, "paypro");
    } else if (!d.success && d.error) {
      message += `${d.message}<br/>`;
    }
  }
  if (message === "") message = "no subscriptions & charges found<br/>";
  return platform + message;
}

export function messageBuilderForFirebase(type, data, forWeb = false) {
  if (!data) return "";
  let usersFound = 0;
  let message = "";
  for (const u of data) {
    if (u.success) {
      const userData = u.user;
      usersFound++;
      const asset = u.asset;
      const userIdMessage = u.id ? `${u.id}` : "— а хз...";
      if (message.length !== 0) message += `<br>`;
      message += `<b><u>Firebase records</u></b><br>`;
      if (forWeb && u.id && asset) {
        try {
          const tokenPayload = { uid: u.id, pid: asset };
          const token = btoa(JSON.stringify(tokenPayload));
          // НЕ МЕНЯТЬ УРЛ! Subscription portal живёт в проекте healthium, не на internal.otion.us
          const portalUrl = `https://app.healthium.one/subscription?token=${encodeURIComponent(token)}`;
          const plainText = `You can manage your subscription yourself in the ${portalUrl}`;
          const htmlText = `You can manage your subscription yourself in the <a href="${portalUrl}">subscription portal</a>`;
          const escapedHtml = htmlText
            .replace(/'/g, "\\'")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
          const escapedPlain = plainText.replace(/'/g, "\\'").replace(/"/g, "&quot;");
          message += `You can manage your subscription yourself in the <a href="${portalUrl}" target="_blank">subscription portal</a> `;
          message += `<button onclick="(async function(e){const btn=e.target;const html='${escapedHtml}'.replace(/&lt;/g,'<').replace(/&gt;/g,'>');const plain='${escapedPlain}';try{await navigator.clipboard.write([new ClipboardItem({'text/html':new Blob([html],{type:'text/html'}),'text/plain':new Blob([plain],{type:'text/plain'})})]);btn.textContent='Copied!';setTimeout(()=>{btn.textContent='Copy';},2000);}catch(err){const ta=document.createElement('textarea');ta.value=plain;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);btn.textContent='Copied!';setTimeout(()=>{btn.textContent='Copy';},2000);}})(event)" style="margin-left: 8px; padding: 2px 8px; font-size: 0.85rem; cursor: pointer; background: #f0f0f0; border: 1px solid #ccc; border-radius: 3px;">Copy</button><br>`;
        } catch (e) {
          // If token generation fails, skip the link
        }
      }
      message += `<b>${asset}</b>: id ${userIdMessage}<br>`;
      if (userData?.purchases?.signup_date) {
        const { signup_date } = userData.purchases;
        let purchaseDate = signup_date?._seconds
          ? new Date(signup_date._seconds * 1000)
          : new Date(signup_date * 1000);

        const daysSinceSignup = Math.floor(
          (Date.now() - purchaseDate.getTime()) / (1000 * 60 * 60 * 24)
        );
        const date = purchaseDate.toLocaleString("en-US", {
          dateStyle: "short",
          timeStyle: "medium"
        });
        message += `<b>Initial purchase:</b> ${formatDate(date)} (${daysSinceSignup} days ago)<br>`;
      }
      const purchaseType = userData?.purchases?.purchase_type;
      message += `<b>Purchase type</b>: ${purchaseType}<br>`;
      if (purchaseType && purchaseType != "android" && purchaseType != "apple") {
        message += `<b>W2W Pass</b>: ${userData?.profile?.password}<br>`;
        message += `<b>W2W Email</b>: ${userData?.profile?.email}<br>`;
      }
    }
  }
  if (usersFound === 0) {
    message += `No users found in Firebase ${type === "html" ? "<br>" : "\n"}`;
  }
  return message;
}

export function initBuilder() {
  uniqueIdCounter = 0;
  objMap.clear();
}

const exportsObj = {
  objMap,
  initBuilder,
  messageBuilderForStripe,
  messageBuilderForPaypro,
  messageBuilderForFirebase
};

// Check if running in CommonJS (Node.js for Firebase)
if (typeof module !== "undefined" && module.exports) {
  module.exports = exportsObj;
}

// ✅ Support ES6 (React Webpack)
export default exportsObj;
